import { Components } from '@mui/material'

import Fonts from '#/styles/Fonts'

export function OverridedList(): Components {
  return {
    MuiListItemText: {
      defaultProps: {
        slots: {
          secondary: 'div',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: Fonts.fontSize.S,
        },
      },
    },
  }
}
